import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from '../features/auth/authSlice';
import activeOrgReducer from '../features/organizations/activeOrgSlice';
import platformStateReducer from '../features/platform/platformStateSlice';
import { baseApi } from '../services/baseApi';
// Import feature slices so their `injectEndpoints` calls register on the base API.
import '../features/auth/authApi';
import '../features/organizations/organizationsApi';
import '../features/territory/territoryApi';
import '../features/aiPlanner/plannerApi';
import '../features/dataSync/dataSyncApi';
import '../features/departments/departmentsApi';
import '../features/resources/resourcesApi';
import '../features/referenceDirectory/referenceDirectoryApi';
import '../features/platform/platformApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    activeOrg: activeOrgReducer,
    platformState: platformStateReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
